import { getClientPath } from '@app/modules/ClientsProfile'

export enum CourtCaseTabNames {
  ChatChronic = 'ChatChronic',
  Invoicing = 'Invoicing'
}

export function getCourtCasePath(
  id: number | string,
  courtCaseUuid: string,
  tab?: CourtCaseTabNames
) {
  const basePath = `${getCourtCasesBasePath(id)}${courtCaseUuid}`

  switch (tab) {
    case CourtCaseTabNames.ChatChronic: {
      return `${basePath}/schriftverkehr`
    }

    case CourtCaseTabNames.Invoicing: {
      return `${basePath}/abrechnung`
    }

    default: {
      return `${basePath}`
    }
  }
}

export function getCourtCasesBasePath(id: number | string) {
  return `${getClientPath(id)}/gerichtsfall/`
}
